import React from 'react';

import { CcbSwitch } from '../../../core/utils/ccb';
import { CcbSwitchName } from '../../../core/utils/ccb/enums';
import { VodPreview } from '../../common/VodPreview/VodPreview';
import { VodScreenType } from '../../common/VodPreview/VodPreviewProps';
import VodListItem from './VodListItem';

import './VodListView.scss';

interface VodListViewProps {
    items: any;
    position: number;
    ghostMode?: boolean;
}

const VodListView: React.FC<VodListViewProps> = ({ items, position, ghostMode = false }) => {
    const isVodPreviewEnabled = CcbSwitch.getInstance().isEnabledAndOverriden(
        CcbSwitchName.ENABLE_VOD_PREVIEW_REMOVE_IN_KST_14762,
    );

    return (
        <React.Fragment>
            {items?.map((item, index) => (
                <VodListItem
                    key={`${item.id}-${index}`}
                    item={item}
                    index={index}
                    isSelected={index === position}
                    ghostMode={index === position && ghostMode}
                />
            ))}
            <div className="vod-my-rentals-preview-container">
                {isVodPreviewEnabled && (
                    <VodPreview
                        screenType={VodScreenType.VOD_MY_RENTAL_LIST_SCREEN}
                        item={items && items.length > 0 ? items[position] : []}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

export default VodListView;
